// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Reactfire from "reactfire";
import * as Onboarding from "../../pages/Onboarding/Onboarding.bs.jsx";
import * as Unauthenticated from "../../pages/Unauthenticated/Unauthenticated.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as FirebaseFirestoreProvider from "../FirebaseFirestoreProvider/FirebaseFirestoreProvider.bs.jsx";

function SignInWrapper(props) {
  let signInStatus = Reactfire.useSigninCheck();
  let match = signInStatus.data;
  if (match === undefined) {
    return null;
  }
  let maybeUser = match.user;
  if (maybeUser !== null && !maybeUser.isAnonymous) {
    return <FirebaseFirestoreProvider.make>
      <Onboarding.make
        user={maybeUser}
      >
        {props.children}
      </Onboarding.make>
    </FirebaseFirestoreProvider.make>;
  } else {
    return <Unauthenticated.make />;
  }
}

let make = SignInWrapper;

export {
  make,
}
/* reactfire Not a pure module */
